export default {"src":"/_next/static/media/remove.5c1da11e.svg","height":25,"width":25};